import React from 'react'
import 'hiq/dist/hiq.min.css'
import 'normalize.css'
import 'focus-visible'

import { ST } from './src/utils/consoleArt'
import { wrapPageElement } from './src/components/Motion'

console.log(ST, 'color: #da2828')
export { wrapPageElement }
